import { Injectable } from "@angular/core";

@Injectable()
export class AppConstants {
public static readonly INPUT_NUMBER_ALLOWED_KEYS = [
    'ArrowLeft',
    'ArrowRight',
    'Shift',
    'Control',
    'Alt',
    'Meta',
    'End',
    'Home',
    'Clear',
    'Tab',
    'CapsLock',
    'Escape',
    'Delete',
    'Enter',
    'Backspace',
  ]
  public static readonly MAX_FILE_SIZE = 1000 * 1000 * 8;
  public static readonly EMAIL_REGEX =
  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  public static readonly PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#&%!~$^_*])[a-zA-Z\d@#&%!~$^_*]{8,}$/;
}
